module.exports = __webpack_public_path__ + "img/logo_1.361590a7.png";